import { render, staticRenderFns } from "./FinancialRatiosListItem.vue?vue&type=template&id=48d70218&scoped=true&lang=pug&"
import script from "./FinancialRatiosListItem.vue?vue&type=script&lang=js&"
export * from "./FinancialRatiosListItem.vue?vue&type=script&lang=js&"
import style0 from "./FinancialRatiosListItem.vue?vue&type=style&index=0&id=48d70218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d70218",
  null
  
)

export default component.exports